import React, { useState, useEffect, useCallback, useRef } from "react";
import { useWatchState, setState, useDebounce } from "@/store";
import { checkResult, createSelectOption } from "@/common";
import { Upload, ImgContainer } from "@/components";
import BraftEditor from "braft-editor";
import { BaseService, uploadUrl, TYCService } from "@/service";
import {
  promotionOrgType,
  orgType,
  orgLevel,
  level,
  conversionType,
} from "@/dic";
import { toArr } from "@/utils";
import {
  Modal,
  Button,
  Form,
  Input,
  message,
  Menu,
  Select,
  Cascader,
  Radio,
  Icon,
  Dropdown,
  Divider,
  Row,
  Col,
  Steps,
  Carousel,
} from "antd";

const { Step } = Steps;
const TABLE_NAME = "thtt_chengguo";
const NAME = "resultHZ";

function cacheOrg(org) {
  localStorage.setItem("cacheOrg", JSON.stringify(org));
}

function getCacheOrg() {
  const cahceOrg = localStorage.getItem("cacheOrg");
  return cahceOrg ? JSON.parse(cahceOrg) : false;
}

// 月份信息
let date = new Date().format().split("-");
date[2] = "01";

async function getNewCode() {
  const res = await BaseService.list({
    table: TABLE_NAME,
    columns: "code,chengguo_id",
    pageSize: 1,
    pageIndex: 1,
    where: {
      is_delete: 0,
      add_time: {
        condition: ">",
        value: Math.floor(new Date(date.join("-")) / 1000),
      },
    },
    order: ["add_time DESC"],
  });
  const code = res.data.result.records[0]
    ? res.data.result.records[0].code
    : "0";
  return !code ? 0 : parseInt(code.substr(-3, 3));
}

const App = Form.create({ name: "register" })(({ form }) => {
  const { getFieldDecorator } = form;

  const [loading, setLoading] = useState(false);

  const [[i18n]] = useWatchState(["i18n"]);
  const [[PLATFORM], [LANG]] = useWatchState(["PLATFORM", "LANG"]);
  const [[user]] = useWatchState(["user"]);
  const [[SCOPE_DIRECTION = []]] = useWatchState(["$_SCOPE_DIRECTION"]);
  const { user_id, authority = "" } = user.info;
  const IS_ADMIN = authority && authority.includes("cg-auditor");
  const IS_INPUT = authority && authority.includes("cg-input");
  const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
  const {
    title = i18n.cloudMatch.releaseBtn.releaseResult,
    show,
    hide,
    width = 900,
    vo = { sub_type: 1 },
    state,
    contrast,
    callback,
    scopes = [],
    files = {},
  } = modalProps;
  const audit = state === "audit";
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[COUNTRY]] = useWatchState(["$_COUNTRY"]);

  const carousel = useRef();
  const [current, setCurrent] = useState(0);
  const [profile, setProfile] = useState("");
  const [orgProfile, setOrgProfile] = useState("");
  const steps = IS_INPUT
    ? [
        { title: i18n.resultModal.steps.recommendOrgTitle },
        { title: i18n.resultModal.steps.resultTitle },
        { title: i18n.resultModal.steps.orgTitle },
      ]
    : [
        { title: i18n.resultModal.steps.resultTitle },
        { title: i18n.resultModal.steps.orgTitle },
      ];

  useEffect(() => {
    if (carousel.current) carousel.current.goTo(current);
  }, [current]);

  const [searchResult = [], setSearchResult] = useState([]);
  const [searchResultPromotion, setSearchResultPromotion] = useState([]);
  const [showSearchRes, setShowSearchRes] = useState(false);
  const [showSearchResPromotion, setShowSearchResPromotion] = useState(false);
  const [selectOrgVo, setSelectOrg] = useState();
  const [selectOrgVoPromotion, setSelectOrgPromotion] = useState();

  useEffect(() => {
    if (!show) {
      setSelectOrg();
      setCurrent(0);
    } else {
      // 设置默认机构
      if (state === "add") {
        const cacheOrg = getCacheOrg();
        if (cacheOrg) selectOrg(cacheOrg);
      }
      if (!IS_INPUT) getMyOrgs();
    }
  }, [show]);

  const orgHandle = async (vo) => {
    const add_time = parseInt(new Date().getTime() / 1000);

    let unit_id = "";
    let org = {};

    if (vo.org_type !== undefined) org.type = vo.org_type;
    if (vo.org_level !== undefined) org.level = vo.org_level;
    if (vo.org_name) org.name = vo.org_name;
    if (vo.org_window_name) org.window_name = vo.org_window_name;
    if (vo.org_web_site) org.web_site = vo.org_web_site;
    if (orgProfile) org.profile = orgProfile;

    // 将成果的负责人、联系人、联系电话赋值给机构
    if (vo.director) org.director = vo.director;
    if (vo.contacts) org.contacts = vo.contacts;
    if (vo.contacts_tel) org.contacts_tel = vo.contacts_tel;

    if (vo.org_provinceName) org.provinceName = vo.org_provinceName;
    if (vo.org_cityName) org.cityName = vo.org_cityName;
    if (vo.org_countyName) org.countyName = vo.org_countyName;
    if (vo.org_province) org.province = vo.org_province;
    if (vo.org_city) org.city = vo.org_city;
    if (vo.org_county) org.county = vo.org_county;
    if (vo.org_country) org.country = vo.org_country;
    if (vo.org_address) org.address = vo.org_address;

    // 保存机构信息
    if (selectOrgVo && selectOrgVo.name === vo.org_name) {
      org.estiblish_time = selectOrgVo.estiblishTime;
      org.legal_person_name = selectOrgVo.legalPersonName;
      org.tyc_org_id = selectOrgVo.id;
      org.tyc_type = selectOrgVo.companyType;
      org.social_credit_code = selectOrgVo.creditCode;
      org.organization_code = selectOrgVo.orgNumber;
      org.reg_number = selectOrgVo.regNumber;
      org.legal_type = selectOrgVo.type;
    }
    // 先查询是否已经存在
    let list = [];
    if (vo.org_name) {
      const getRes = await BaseService.list({
        table: "thtt_organization",
        where: {
          name: vo.org_name,
          is_delete: 0,
        },
      });
      list = getRes.data.result;
    }

    // 修改
    if (list.length) {
      const organization_id = list[0].organization_id;
      unit_id = organization_id;
      await BaseService.put({
        table: "thtt_organization",
        data: org,
        where: { organization_id },
      });
    } else {
      // 新增
      if (!org.name) return;
      const addRes = await BaseService.add({
        table: "thtt_organization",
        data: {
          ...org,
          is_delete: 0,
          add_time,
          audit_status: 4,
          user_id: user_id,
          type: 5,
        },
        key: "organization_id",
      });
      if (!checkResult(addRes)) return setLoading(false);
      unit_id = addRes.data.result.organization_id;

      // 新增机构用户
      const addUserRes = await BaseService.add({
        table: "thtt_organization_user",
        data: {
          organization_id: unit_id,
          user_id: user_id,
          is_admin: 1,
          is_delete: 0,
          add_time,
          audit_status: 4,
        },
      });
      if (!checkResult(addUserRes)) return setLoading(false);
    }

    cacheOrg(org);

    return unit_id;
  };
  const orgHandlePromotion = async (vo) => {
    const add_time = parseInt(new Date().getTime() / 1000);

    let unit_id = "";
    let org = {};
    if (vo.promotion_org_promotion_type !== undefined)
      org.promotion_type = vo.promotion_org_promotion_type;
    if (vo.promotion_org_name) org.name = vo.promotion_org_name;
    if (vo.promotion_org_province) org.province = vo.promotion_org_province;
    if (vo.promotion_org_provinceName)
      org.provinceName = vo.promotion_org_provinceName;
    if (vo.promotion_org_city) org.city = vo.promotion_org_city;
    if (vo.promotion_org_cityName) org.cityName = vo.promotion_org_cityName;
    if (vo.promotion_org_county) org.county = vo.promotion_org_county;
    if (vo.promotion_org_countyName)
      org.countyName = vo.promotion_org_countyName;
    if (vo.promotion_org_address) org.address = vo.promotion_org_address;
    if (vo.promotion_org_web_site) org.web_site = vo.promotion_org_web_site;

    // 先查询是否已经存在
    let list = [];
    if (vo.promotion_org_name) {
      const getRes = await BaseService.list({
        table: "thtt_organization",
        where: {
          name: vo.promotion_org_name,
          is_delete: 0,
        },
      });
      list = getRes.data.result;
    }

    // 修改
    if (list.length) {
      const organization_id = list[0].organization_id;
      unit_id = organization_id;
      await BaseService.put({
        table: "thtt_organization",
        data: org,
        where: { organization_id },
      });
    } else {
      // 新增
      if (!org.name) return;
      const addRes = await BaseService.add({
        table: "thtt_organization",
        data: { ...org, is_delete: 0, add_time, audit_status: 4 },
        key: "organization_id",
      });
      if (!checkResult(addRes)) return setLoading(false);
      unit_id = addRes.data.result.organization_id;
    }

    return unit_id;
  };

  const add = async (vo) => {
    const add_time = parseInt(new Date().getTime() / 1000);
    setLoading(true);

    const unit_id = await orgHandle(vo);
    const promotion_org = await orgHandlePromotion(vo);

    const num = await getNewCode();
    const type = promotionOrgType.find(
      (item) => item.value === vo.promotion_org_promotion_type
    ) || { code: "GRZZ" };
    const code =
      "CG" +
      type.code +
      date[0].substr(-2, 2) +
      date[1] +
      (num + 1 + "").padStart(3, 0);

    if (!user_id) {
      message.error("用户信息错误！");
      return;
    }

    try {
      let data = {
        ...vo,
        code,
        platform: PLATFORM,
        add_time,
        release_time: add_time,
        sort_time: add_time,
        unit: unit_id,
        promotion_org,
        is_delete: 0,
        add_user: user_id,
        audit_status: 1,
        complete_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
      };
      if (IS_ADMIN) data.audit_status = 4;

      const res = await BaseService.add({
        table: TABLE_NAME,
        data,
        key: "chengguo_id",
      });
      if (!checkResult(res)) return setLoading(false);
      const chengguo_id = res.data.result.chengguo_id;
      // 保存成果领域
      const scopeRes = await BaseService.adds({
        table: "thtt_chengguo_scope",
        data: JSON.stringify(
          scopes.map(({ value, pid }) => ({
            chengguo_id,
            first_scope_id: pid,
            second_scope_id: value,
          }))
        ),
      });
      let _files = [];
      Object.values(files).forEach((arr) => (_files = _files.concat(arr)));
      const addFileRes = await BaseService.adds({
        table: "thtt_attachment_relation",
        data: JSON.stringify(
          _files.map((val) => ({ ...val, item_id: chengguo_id }))
        ),
      });
      setLoading(false);
      if (!checkResult(scopeRes)) return;
      message.success(i18n.releaseSuccess);

      // 提示是否需要智能匹配
      // confirmMatch({
      //   type: "result",
      //   defaultFileList: _files,
      //   onOk: async function (resFiles) {
      //     if (!resFiles.length) {
      //       message.warn("您没有上传更多的材料，暂时无法为您进行匹配服务！");
      //       return;
      //     }
      //     await BaseService.put({
      //       table: "thtt_chengguo",
      //       where: {
      //         chengguo_id,
      //       },
      //       data: {
      //         level: 1,
      //       },
      //     });
      //     await BaseService.remove({
      //       table: "thtt_attachment_relation",
      //       where: {
      //         item_id: chengguo_id,
      //         type: JSON.stringify(Object.keys(files)),
      //       },
      //     });
      //     await BaseService.adds({
      //       table: "thtt_attachment_relation",
      //       data: JSON.stringify(resFiles),
      //     });
      //     if (callback) callback();
      //   },
      //   onCancel: function () {},
      // });

      hide();
      if (callback) callback();
    } catch (error) {
      setLoading(false);
    }
  };

  const put = async (values) => {
    const update_time = Math.floor(new Date() / 1000);
    let vo = contrast(values, ["chengguo_id", "org_name"]);
    setLoading(true);
    try {
      const unit_id = await orgHandle(vo);
      const promotion_org = await orgHandlePromotion(vo);

      const res = await BaseService.put({
        table: TABLE_NAME,
        data: { ...vo, update_time, unit: unit_id, promotion_org },
        where: { chengguo_id: vo.chengguo_id },
      });
      if (!checkResult(res)) return setLoading(false);

      await BaseService.remove({
        table: "thtt_chengguo_scope",
        where: {
          chengguo_id: vo.chengguo_id,
        },
      });
      await BaseService.adds({
        table: "thtt_chengguo_scope",
        data: JSON.stringify(
          scopes.map(({ value, pid }) => ({
            chengguo_id: vo.chengguo_id,
            first_scope_id: pid,
            second_scope_id: value,
          }))
        ),
      });
      let _files = [];
      Object.values(files).forEach((arr) => (_files = _files.concat(arr)));
      await BaseService.remove({
        table: "thtt_attachment_relation",
        where: {
          item_id: vo.chengguo_id,
          type: JSON.stringify(Object.keys(files)),
        },
      });
      await BaseService.adds({
        table: "thtt_attachment_relation",
        data: JSON.stringify(_files),
      });

      setLoading(false);
      message.success("修改成功！");
      hide();
      if (callback) callback();
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };

  const funs = { add, put };

  const checkSubmit = (index) => {
    form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        setCurrent(index);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const data = { ...vo, ...values, cover: vo.cover };

        if (!profile && !data.old_profile)
          return message.warn("Please enter the introduction of the results!");

        data.profile = profile || data.old_profile;

        // 如果是已审核状态，提示需要重新审核！
        if (!IS_ADMIN && vo.audit_status === 4) {
          Modal.confirm({
            title: "Are you sure to modify the result information?",
            content:
              "After submitting the modification, the administrator needs to review it again!",
            onOk() {
              data.audit_status = 1;
              funs[state](data);
            },
          });
          return;
        }

        funs[state](data);
      }
    });
  };

  const onUploadFinish = (e) => {
    const url = e.file.response.files[0].url;
    modalProps.vo.cover = url;
    setProps({ ...modalProps });
  };

  const onUploadFileFinish = (type, e) => {
    const size = e.file.size;
    const add_time = new Date().format("yyyy-MM-dd hh:mm:ss");
    const newFiles = e.file.response.files.map(
      ({ fileShowName, suffix, url }) => ({
        type,
        item_id: vo.chengguo_id,
        file_name: fileShowName,
        file_path: url,
        file_suffix: suffix,
        size,
        add_time,
      })
    );
    if (!modalProps.files) modalProps.files = {};
    if (!modalProps.files[type]) modalProps.files[type] = newFiles;
    else modalProps.files[type] = modalProps.files[type].concat(newFiles);
    setProps({ ...modalProps });
  };
  const onRemoveFile = (type, file) => {
    modalProps.files[type].remove(file.uid - 1);
    setProps({ ...modalProps });
  };

  // 选中搜索结果
  const selectOrg = (org) => {
    const { name } = org;
    setSelectOrg(org);
    form.setFieldsValue({
      org_name: name,
    });
    getAndRefreshOrg(name);
    cacheOrg(org);
  };
  const selectOrgPromotion = (org) => {
    const { name } = org;
    setSelectOrgPromotion(org);
    form.setFieldsValue({
      promotion_org_name: name,
    });
    getAndRefreshOrgPromotion(name);
  };

  const getAndRefreshOrg = (name) => {
    BaseService.list({
      table: "thtt_organization",
      columns: [
        "organization_id",
        "name",
        "type",
        "level",
        "window_name",
        "web_site",
        "director",
        "profile",
        "reg_location",
        "contacts",
        "contacts_tel",
        "contacts_email",
        "wechat",
        "economic_circle",
        "staff_num_range",
        "talent",
        "equipment",
        "business_direction",
        "performance",
        "team_scale",
        "province",
        "city",
        "county",
        "country",
        "provinceName",
        "cityName",
        "countyName",
        "address",
      ]
        .map((field) => `${field} AS org_${field}`)
        .join(","),
      where: { name, is_delete: 0 },
    }).then((res) => {
      if (!checkResult(res)) return;
      const data = res.data.result;
      if (data.length) {
        const org = data[0];
        org.org_profile = BraftEditor.createEditorState(org.org_profile);
        modalProps.vo.org_region_id = [
          vo.org_province,
          vo.org_city,
          vo.org_county,
        ];

        // 将机构的负责人、联系人、联系信息赋值给成果
        modalProps.vo.director = org.org_director;
        modalProps.vo.contacts = org.org_contacts;
        modalProps.vo.contacts_tel = org.org_contacts_tel;
        modalProps.vo.contacts_email = org.org_contacts_email;

        modalProps.vo = {
          ...modalProps.vo,
          ...org,
        };
        setTimeout(() => {
          setProps({ ...modalProps });
        });
        form.setFieldsValue(org);
      }
    });
  };
  const getAndRefreshOrgPromotion = (name) => {
    BaseService.list({
      table: "thtt_organization",
      columns: [
        "organization_id",
        "promotion_type",
        "address",
        "web_site",
        "type",
        "profile",
        "reg_location",
        "wechat",
        "economic_circle",
        "staff_num_range",
        "talent",
        "equipment",
        "business_direction",
        "performance",
        "team_scale",
        "province",
        "city",
        "county",
        "provinceName",
        "cityName",
        "countyName",
      ]
        .map((field) => `${field} AS promotion_org_${field}`)
        .join(","),
      where: { name, is_delete: 0 },
    }).then((res) => {
      if (!checkResult(res)) return;
      const data = res.data.result;
      if (data.length) {
        const org = data[0];
        modalProps.vo.promotion_org_region_id = [
          vo.promotion_org_province,
          vo.promotion_org_city,
          vo.promotion_org_county,
        ];
        modalProps.vo = {
          ...modalProps.vo,
          ...org,
        };
        setProps({ ...modalProps });
        form.setFieldsValue(org);
      }
    });
  };

  const getMenu = (data = []) => {
    return (
      <Menu
        className="search_result_list"
        style={{ height: "200px", overflow: "auto" }}
      >
        {data.map((org) => (
          <Menu.Item
            keys={org.name}
            onClick={selectOrg.later({
              ...org,
              name: org.name && org.name.getBytesContent(),
            })}
          >
            <div dangerouslySetInnerHTML={{ __html: org.name }} />
          </Menu.Item>
        ))}
      </Menu>
    );
  };
  const getMenuPromotion = (data = []) => {
    return (
      <Menu
        className="search_result_list"
        style={{ height: "200px", overflow: "auto" }}
      >
        {data.map((org) => (
          <Menu.Item
            keys={org.name}
            onClick={selectOrgPromotion.later({
              ...org,
              name: org.name.getBytesContent(),
            })}
          >
            <div dangerouslySetInnerHTML={{ __html: org.name }} />
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  const onChnageOrgName = useDebounce((word) => {
    if (IS_INPUT)
      TYCService.search({ word }).then(
        (res) => {
          if (!checkResult(res)) return;
          setSearchResult(res.data.result.records || res.data.result.items);
        },
        (err) => {
          throw err;
        }
      );
    else
      BaseService.list({
        table: "thtt_organization_user",
        leftJoin: {
          table: "thtt_organization",
          on: "thtt_organization.organization_id = thtt_organization_user.organization_id",
          columns: ["name"],
        },
        where: {
          "thtt_organization_user.user_id": user_id,
          "thtt_organization.name": {
            condition: "LIKE",
            value: word,
          },
          "thtt_organization.is_delete": 0,
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        setSearchResult(res.data.result);
      });
  }, 200);

  const getMyOrgs = useCallback(() => {
    BaseService.list({
      table: "thtt_organization_user",
      leftJoin: {
        table: "thtt_organization",
        on: "thtt_organization.organization_id = thtt_organization_user.organization_id",
        columns: ["name"],
      },
      where: {
        "thtt_organization_user.user_id": user_id,
        "thtt_organization.is_delete": 0,
      },
    }).then((res) => {
      if (!checkResult(res)) return;
      setSearchResult(res.data.result);
    });
  }, []);

  const onChnageOrgNamePromotion = useDebounce((word) => {
    TYCService.search({ word }).then(
      (res) => {
        if (!checkResult(res)) return;
        setSearchResultPromotion(
          res.data.result.records || res.data.result.items
        );
      },
      (err) => {
        throw err;
      }
    );
  }, 200);

  const onChangeOrgProfile = (e) => {
    setOrgProfile(e.toHTML());
  };

  const onChangeProfile = (e) => {
    setProfile(e.toHTML());
  };

  return (
    <Modal
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      onCancel={hide}
      footer={
        <div>
          {current > 0 && (
            <Button onClick={checkSubmit.bind(null, current - 1)}>
              {i18n.resultModal.back}
            </Button>
          )}
          {current !== steps.length - 1 && (
            <Button onClick={checkSubmit.bind(null, current + 1)}>
              {i18n.resultModal.next}
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button onClick={handleSubmit}>{i18n.resultModal.submit}</Button>
          )}
        </div>
      }
      destroyOnClose={true}
    >
      <div className={audit && "not-allowed"}>
        {/* 进度 */}
        <Steps type="navigation" current={current}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div
          className="over-y-auto over-x-hide m-md-t"
          style={{ height: "60vh" }}
        >
          <Form onSubmit={handleSubmit} className={audit && "no-click"}>
            <Carousel ref={carousel} dots={false}>
              {/* 推介机构信息 */}
              {IS_INPUT && (
                <div>
                  <Row gutter={18}>
                    <Col span={8}>
                      <Form.Item label={i18n.resultModal.recommendOrgForm.name}>
                        <Dropdown
                          overlay={getMenuPromotion(searchResultPromotion)}
                          visible={
                            searchResultPromotion.length &&
                            showSearchResPromotion
                          }
                        >
                          {getFieldDecorator("promotion_org_name", {
                            initialValue: vo.promotion_org_name,
                          })(
                            <Input
                              onChange={(e) => {
                                const word = e.target.value;
                                if (!word) {
                                  setSearchResultPromotion([]);
                                  return;
                                }
                                if (word) onChnageOrgNamePromotion(word);
                              }}
                              maxLength={100}
                              onFocus={setShowSearchResPromotion.later(true)}
                              onBlur={() =>
                                setTimeout(
                                  () => setShowSearchResPromotion(false),
                                  100
                                )
                              }
                              placeholder={
                                i18n.resultModal.recommendOrgForm
                                  .namePlaceholder
                              }
                              autoComplete="off"
                            />
                          )}
                        </Dropdown>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label={i18n.resultModal.recommendOrgForm.type}>
                        {getFieldDecorator("promotion_org_promotion_type", {
                          initialValue: vo.promotion_org_promotion_type,
                        })(
                          <Select
                            placeholder={
                              i18n.resultModal.recommendOrgForm.typePlaceholder
                            }
                          >
                            {createSelectOption(promotionOrgType, LANG)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={i18n.resultModal.recommendOrgForm.webSite}
                      >
                        {getFieldDecorator("promotion_org_web_site", {
                          initialValue: vo.promotion_org_web_site,
                        })(
                          <Input
                            maxLength={200}
                            placeholder={
                              i18n.resultModal.recommendOrgForm
                                .webSitePlaceholder
                            }
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={i18n.resultModal.recommendOrgForm.contacts}
                      >
                        {getFieldDecorator("promotion_org_contacts", {
                          initialValue: vo.promotion_org_contacts,
                        })(
                          <Input
                            maxLength={50}
                            placeholder={
                              i18n.resultModal.recommendOrgForm
                                .contactsPlaceholder
                            }
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={i18n.resultModal.recommendOrgForm.contactsTel}
                      >
                        {getFieldDecorator("promotion_org_contacts_tel", {
                          initialValue: vo.promotion_org_contacts_tel,
                        })(
                          <Input
                            maxLength={100}
                            placeholder={
                              i18n.resultModal.recommendOrgForm
                                .contactsTelPlaceholder
                            }
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={i18n.resultModal.recommendOrgForm.contactsEmail}
                      >
                        {getFieldDecorator("promotion_org_contacts_email", {
                          initialValue: vo.promotion_org_contacts_email,
                          rules: [
                            {
                              required: true,
                              message:
                                i18n.demandModal.orgForm.contactsEmailMessage,
                            },
                          ],
                        })(
                          <Input
                            maxLength={200}
                            placeholder={
                              i18n.resultModal.recommendOrgForm
                                .contactsEmailPlaceholder
                            }
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Form.Item
                        label={i18n.resultModal.recommendOrgForm.address}
                      >
                        {getFieldDecorator("promotion_org_address", {
                          initialValue: vo.promotion_org_address,
                        })(
                          <Input
                            maxLength={500}
                            placeholder={
                              i18n.resultModal.recommendOrgForm
                                .addressPlaceholder
                            }
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}
              {/* 成果信息 */}
              <div>
                {current > (IS_INPUT ? 0 : -1) && (
                  <div>
                    <Row gutter={18}>
                      <Col span={12}>
                        <Form.Item label={i18n.resultModal.resultForm.name}>
                          {getFieldDecorator("name", {
                            initialValue: vo.name,
                            rules: [
                              {
                                required: true,
                                message:
                                  i18n.resultModal.resultForm.nameMessage,
                              },
                            ],
                          })(
                            <Input
                              maxLength={200}
                              placeholder={
                                i18n.resultModal.resultForm.namePlaceholder
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label={i18n.resultModal.resultForm.scope}>
                          {getFieldDecorator("scope", {
                            initialValue: toArr(vo.scope),
                            rules: [
                              {
                                required: true,
                                message:
                                  i18n.resultModal.resultForm.scopeMessage,
                              },
                            ],
                          })(
                            <Select
                              placeholder={
                                i18n.resultModal.resultForm.scopePlaceholder
                              }
                              mode="multiple"
                            >
                              {createSelectOption(
                                (SCOPE_DIRECTION || []).map((val) => ({
                                  ...val,
                                  en: val.name_en,
                                })),
                                LANG
                              )}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label={i18n.resultModal.resultForm.cover}>
                          {getFieldDecorator("cover", {
                            initialValue: vo["cover"],
                          })(
                            <Upload
                              style={{ minWidth: "160px" }}
                              accept=".jpg,.jpeg,.png"
                              name="files"
                              listType="picture-card"
                              showUploadList={false}
                              onFinish={onUploadFinish}
                              action={uploadUrl}
                            >
                              {vo["cover"] ? (
                                <ImgContainer
                                  src={
                                    "http://" + UPLOAD_SERVER_HOST + vo["cover"]
                                  }
                                  width={150}
                                  scale={9 / 16}
                                />
                              ) : (
                                i18n.resultModal.resultForm.coverPlaceholder
                              )}
                            </Upload>
                          )}
                        </Form.Item>
                      </Col>
                      {!audit && (
                        <Col span={12}>
                          <Form.Item
                            label={i18n.resultModal.resultForm.enclosure}
                          >
                            {getFieldDecorator("enclosure", {
                              initialValue: vo["enclosure"],
                            })(
                              <Upload
                                style={{ minWidth: "160px" }}
                                name="files"
                                onFinish={onUploadFileFinish.later("enclosure")}
                                action={uploadUrl}
                                defaultFileList={(files.enclosure || []).map(
                                  ({ file_name, file_path }, i) => ({
                                    name: file_name,
                                    url: `http://${UPLOAD_SERVER_HOST}${file_path}`,
                                    status: "done",
                                    uid: i + 1,
                                  })
                                )}
                                onRemove={onRemoveFile.later("enclosure")}
                              >
                                <Button>
                                  <Icon type="upload" />{" "}
                                  {i18n.resultModal.resultForm.uploadBtnTitle}
                                </Button>
                              </Upload>
                            )}
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    <Row gutter={18}>
                      {IS_INPUT && (
                        <Col span={12}>
                          <Form.Item label={i18n.resultModal.resultForm.level}>
                            {getFieldDecorator("level", {
                              initialValue: vo.level,
                            })(
                              <Select
                                placeholder={
                                  i18n.resultModal.resultForm.levelPlaceholder
                                }
                              >
                                {createSelectOption(level)}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      )}
                      {IS_INPUT && (
                        <Col span={12}>
                          <Form.Item
                            label={i18n.resultModal.resultForm.conversionType}
                          >
                            {getFieldDecorator("conversion_type", {
                              initialValue: toArr(vo.conversion_type),
                            })(
                              <Select
                                placeholder={
                                  i18n.resultModal.resultForm
                                    .conversionTypePlaceholder
                                }
                                mode="multiple"
                              >
                                {createSelectOption(conversionType, LANG)}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    <Form.Item
                      label={i18n.resultModal.resultForm.profile}
                      required
                    >
                      <BraftEditor
                        className="border bor-ra-xs"
                        language="en"
                        defaultValue={vo.profile}
                        onChange={onChangeProfile}
                        placeholder={
                          i18n.resultModal.resultForm.profilePlaceholder
                        }
                      />
                    </Form.Item>
                  </div>
                )}
              </div>
              {/* 成果所属机构\个人信息 */}
              <div>
                {current > (IS_INPUT ? 1 : 0) && (
                  <div>
                    <Form.Item label={i18n.resultModal.orgForm.type}>
                      {getFieldDecorator("sub_type", {
                        initialValue: vo.sub_type,
                        rules: [
                          {
                            required: true,
                          },
                        ],
                      })(
                        <Radio.Group
                          onChange={(e) =>
                            setState(
                              "modal." + NAME + ".vo.sub_type",
                              e.target.value
                            )
                          }
                        >
                          <Radio value={1}>
                            {i18n.resultModal.orgForm.typeOrg}
                          </Radio>
                          <Radio value={2}>
                            {i18n.resultModal.orgForm.typeSelf}
                          </Radio>
                        </Radio.Group>
                      )}
                    </Form.Item>
                    <Row gutter={18}>
                      {vo.sub_type === 1 && (
                        <Col span={12}>
                          <Form.Item label={i18n.resultModal.orgForm.orgName}>
                            <Dropdown
                              overlay={getMenu(searchResult)}
                              visible={searchResult.length && showSearchRes}
                            >
                              {getFieldDecorator("org_name", {
                                initialValue: vo.org_name,
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      i18n.resultModal.orgForm.orgNameMessage,
                                  },
                                ],
                              })(
                                <Input
                                  onChange={(e) => {
                                    const word = e.target.value;
                                    if (!word) {
                                      setSearchResult([]);
                                      getMyOrgs();
                                      return;
                                    }
                                    if (word) onChnageOrgName(word);
                                  }}
                                  maxLength={100}
                                  onFocus={setShowSearchRes.later(true)}
                                  onBlur={() =>
                                    setTimeout(
                                      () => setShowSearchRes(false),
                                      100
                                    )
                                  }
                                  placeholder={
                                    i18n.resultModal.orgForm.orgNamePlaceholder
                                  }
                                  autoComplete="off"
                                />
                              )}
                            </Dropdown>
                          </Form.Item>
                        </Col>
                      )}
                      {vo.sub_type === 2 && (
                        <Col span={12}>
                          <Form.Item label={i18n.resultModal.orgForm.director}>
                            {getFieldDecorator("director", {
                              initialValue: vo.director || "",
                              rules: [
                                {
                                  required: true,
                                  message:
                                    i18n.resultModal.orgForm.directorMessage,
                                },
                              ],
                            })(
                              <Input
                                maxLength={20}
                                placeholder={
                                  i18n.resultModal.orgForm.directorPlaceholder
                                }
                              />
                            )}
                          </Form.Item>
                        </Col>
                      )}
                      {vo.sub_type === 2 && (
                        <Col span={12}>
                          <Form.Item label={i18n.resultModal.orgForm.number}>
                            {getFieldDecorator("id_number", {
                              initialValue: vo.id_number,
                              rules: [
                                {
                                  required: true,
                                  message:
                                    i18n.resultModal.orgForm.numberMessage,
                                },
                              ],
                            })(
                              <Input
                                maxLength={100}
                                placeholder={
                                  i18n.resultModal.orgForm.numberPlaceholder
                                }
                              />
                            )}
                          </Form.Item>
                        </Col>
                      )}
                      {vo.sub_type === 1 && (
                        <Col span={12}>
                          <Form.Item label={i18n.resultModal.orgForm.orgType}>
                            {getFieldDecorator("org_type", {
                              initialValue: vo.org_type,
                              rules: [
                                {
                                  required: true,
                                  message:
                                    i18n.resultModal.orgForm.orgTypeMessage,
                                },
                              ],
                            })(
                              <Select
                                placeholder={
                                  i18n.resultModal.orgForm.orgTypePlaceholder
                                }
                              >
                                {createSelectOption(orgType, LANG)}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      )}
                      {vo.sub_type === 1 && (
                        <Col span={12}>
                          <Form.Item label={i18n.resultModal.orgForm.orgLevel}>
                            {getFieldDecorator("org_level", {
                              initialValue: vo.org_level,
                            })(
                              <Select
                                placeholder={
                                  i18n.resultModal.orgForm.orgLevelPlaceholder
                                }
                              >
                                {createSelectOption(orgLevel, LANG)}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      )}
                      {vo.sub_type === 1 && (
                        <Col span={24}>
                          <Form.Item
                            label={i18n.resultModal.orgForm.orgProfile}
                          >
                            <BraftEditor
                              className="border bor-ra-xs"
                              language="en"
                              defaultValue={vo.org_profile}
                              onChange={onChangeOrgProfile}
                              placeholder={
                                i18n.resultModal.orgForm.orgProfilePlaceholder
                              }
                            />
                          </Form.Item>
                        </Col>
                      )}
                      {vo.sub_type === 1 && (
                        <Col span={8}>
                          <Form.Item label={i18n.resultModal.orgForm.director}>
                            {getFieldDecorator("director", {
                              initialValue: vo.director || "",
                            })(
                              <Input
                                maxLength={50}
                                placeholder={
                                  i18n.resultModal.orgForm.directorMessage
                                }
                              />
                            )}
                          </Form.Item>
                        </Col>
                      )}

                      <Col span={8}>
                        <Form.Item label={i18n.demandModal.orgForm.country}>
                          {getFieldDecorator("org_country", {
                            initialValue:
                              vo.org_country && parseInt(vo.org_country),
                            rules: [
                              {
                                required: true,
                                message:
                                  i18n.demandModal.orgForm.countryMessage,
                              },
                            ],
                          })(
                            <Select
                              showSearch
                              placeholder={
                                i18n.demandModal.orgForm.countryPlaceholder
                              }
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {createSelectOption(COUNTRY, LANG, "en_name")}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={i18n.resultModal.orgForm.contacts}>
                          {getFieldDecorator("contacts", {
                            initialValue: vo.contacts,
                            rules: [
                              {
                                required: true,
                                message:
                                  i18n.resultModal.orgForm.contactsMessage,
                              },
                            ],
                          })(
                            <Input
                              maxLength={50}
                              placeholder={
                                i18n.resultModal.orgForm.contactsPlaceholder
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label={i18n.demandModal.orgForm.contactsEmail}
                        >
                          {getFieldDecorator("contacts_email", {
                            initialValue: vo.contacts_email,
                            rules: [
                              {
                                required: true,
                                message:
                                  i18n.demandModal.orgForm.contactsEmailMessage,
                              },
                            ],
                          })(
                            <Input
                              maxLength={100}
                              placeholder={
                                i18n.demandModal.orgForm
                                  .contactsEmailPlaceholder
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label={i18n.resultModal.orgForm.address}>
                          {getFieldDecorator("org_address", {
                            initialValue: vo.org_address,
                          })(
                            <Input
                              maxLength={100}
                              placeholder={
                                i18n.resultModal.orgForm.addressPlaceholder
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>
                      {vo.sub_type === 1 && (
                        <Col span={24}>
                          <Form.Item label={i18n.resultModal.orgForm.webSite}>
                            {getFieldDecorator("org_web_site", {
                              initialValue: vo.org_web_site,
                            })(
                              <Input
                                maxLength={200}
                                placeholder={
                                  i18n.resultModal.orgForm.webSitePlaceholder
                                }
                              />
                            )}
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </div>
                )}
              </div>
            </Carousel>
          </Form>
        </div>
      </div>
    </Modal>
  );
});

export default App;
